
import React from 'react';
import { PickTicketRefreshConfirmationModalTemplate } from 'themes/application/pick-ticket-new-flow/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { PickTicketRefreshConfirmationModalStore } from 'application/pick-ticket-new-flow/stores';

@setCurrentView((rootStore, componentProps) => new PickTicketRefreshConfirmationModalStore(rootStore, componentProps), 'pickTicketRefreshConfirmationModalStore')
@observer
class PickTicketRefreshConfirmationModal extends React.Component {
    render() {
        return <PickTicketRefreshConfirmationModalTemplate {...this.props} />
    }
}

export default PickTicketRefreshConfirmationModal;
